<template>
  <!-- 顯示Image -->
  <img v-if="imageContent" :src="imageContent" alt="QR Code" class="qr-code-img" />
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { generateQRCode, isEmpty, QRCodeBaseOptions, QRCodeMode } from '@ipevo-rd/service-web-utils'

export default defineComponent({
  name: 'QRCode',
  props: {
    /**
     * QR Code Options
     */
    options: {
      type: Object as PropType<QRCodeBaseOptions>,
      required: true,
    },
  },
  data() {
    return {
      // QR Code Image Content
      imageContent: null as string | null,
    }
  },
  methods: {
    /**
     * Generate QR Code
     * @async
     * @return {Promise<void>}
     */
    async generate(): Promise<void> {
      // 如果為下載圖片模式則不執行
      if (this.options.mode === QRCodeMode.DownloadImage) {
        return
      }

      // 產生 QR Code
      const result = await generateQRCode(this.options)
      //如果是 null 或者 型別是 boolean，則不處理
      if (isEmpty(result)) {
        return
      }

      // 取得產生出來後的Element並取得影像的content
      this.imageContent = this.options.mode === QRCodeMode.GenerateImage ? (result as HTMLImageElement).src : (result as HTMLCanvasElement).toDataURL()
    },
  },
  async mounted() {
    await this.generate()
  },
})
</script>
<style lang="scss">
.qr-code-img {
  padding: 4px;
  border-radius: 16px;
}
</style>
